import React from 'react';
import {Link} from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import ReactTable from 'react-table';
import firebase from 'firebase/app';
import 'firebase/database';
import ReactFireComponent from '../react-fire-component/react-fire-component';

/** @class
  * A component providing a dashboard for an exhibitor, allowing
  * them to review thier booths.
  */
export default class ExhibitorDashboard extends ReactFireComponent {

  /** @constructor
    * Constructs a new exhibitor dashboard instance
    */
  constructor(props){
    super(props);
    this.state = {booths: []}
  }

  /** @method componentWillMount
    * Binds the component to the firebase database
    */
  componentWillMount(){
    firebase.database().ref(`/users/${this.props.uid}/exhibitorID`).once('value', snapshot => {
      const exhibitorID = snapshot.val();
      this.bindAsArray(`/exhibitors/${exhibitorID}/booths`, 'booths');
    });
  }

  /** @method componentWillUnmount
    * Unbinds the component from the firebase database
    */
  componentWillUnmount(){
    this.unbind('booths');
  }

  /** @method render
    * Renders the exhibitor dashboard
    */
  render() {
    const columns = [
      {Header: "Booth", accessor: "name"},
      {Header: "Expo", accessor: "expo"},
      {Header: "Show", accessor: "show"},
      {Header: "Status", accessor: "status"},
      {Header: "Review", accessor: "url", Cell: (row) => (
        <div style={{textAlign: "center"}}>
          <Link to={row.value} style={{color: 'orange'}}>
            <FontAwesome name="eye"
              style={{color: 'orange'}}
              />
              &nbsp;Review Booth
          </Link>
        </div>
      )}
    ];
    const data = this.state.booths.map(booth => {
      booth.url = `/expos/${booth.expo}/shows/${booth.show}/booths/${booth.id}/review`;
      return booth;
    });
    return (
      <ReactTable
        className="-striped"
        data={data}
        columns={columns}
        defaultPageSize={15}
        />
    );
  }
}



// WEBPACK FOOTER //
// ./src/dashboard/exhibitor-dashboard.js